import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('authtoken');
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && (result.error.status === 401)) {
    localStorage.removeItem('authtoken');
  }
  return result;
};

export const MemberApi = createApi({
  reducerPath: 'MemberApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getMemberList: builder.query({
      query: (params) => ({
        url: `/member/member-list`,
        params
      })
    }),
    getFilteredMemberList: builder.query({
      query: (filters) => ({
        url: `/member/member-list-page`,
        params: filters,
      }),
    }),

    postMember: builder.mutation({
      query: (data) => ({
        url: `/member/member-create/`,
        method: "POST",
        body: data,
      }),
    }),
    deleteMember: builder.mutation({
      query: (id) => {
        return {
          url: `/member/member-delete/${id}/`,
          method: "DELETE",
        };
      },
    }),
    updateMember: builder.mutation({
      query: ({ data, user_id }) => {

        return {
          url: `/member/member-edit/${user_id}/`,
          method: "PUT",
          body: data,
          formData: true,
        };
      },
    }),
    getMemberquestions: builder.query({
      query: (data) => ({
        url: `/member/meal-questions`,
        body: data
      })
    }),
    getMembervideos: builder.query({
      query: (params) => ({
        url: `/member/video-list`,
        params
      })
    }),
    memberDetails: builder.query({
      query: (id) => {
        return {
          url: `/member/member-detail/${id}/`,

        }
      }
    }),
    getMemberfilterdAttendanceList: builder.query({
      query: (filters) => ({
        url: `/member/attendance/list`,
        params: filters,
      }),
    }),
    verifyQR: builder.mutation({
      query: (body) => ({
        url: "/member/verify-qr",
        method: "POST",
        body:body,
      }),
    }),
    checkIn: builder.mutation({
      query: (data) => ({
        url: "/member/attendance/check-in/",
        method: "POST",
        body: data
      }),
    }),
    
    checkOut: builder.mutation({
      query: (body) => ({
        url: "/member/attendance/check-out",
        method: "POST",
        body: body,
      }),
    }),
    getCheckInLogs: builder.query({
      query: () => ({
        url: `/member/checkin-logs/`,
      }),
    }),
 getAppointmentDetail: builder.query({
      query: (id) => ({
        url: `/member/appointment/detail/${id}/`,
        method: "GET",
      }),
    }),
    updateAppointmentStatus: builder.mutation({
  query: ({ appointment_id, data }) => ({
    url: `/member/appointments/${appointment_id}/update-status/`,
    method: "PATCH",
    body: data,
  }),
}),




  }),
})


export const { useVerifyQRMutation,useCheckOutMutation,useCheckInMutation,useGetMemberfilterdAttendanceListQuery, useGetMembervideosQuery, useGetMemberquestionsQuery, useGetMemberListQuery, usePostMemberMutation, useDeleteMemberMutation, useUpdateMemberMutation, useMemberDetailsQuery, useGetFilteredMemberListQuery,useGetCheckInLogsQuery,useGetAppointmentDetailQuery,useUpdateAppointmentStatusMutation } = MemberApi
